<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-18 16:00:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/cart/components/ProductList/index.vue
-->
<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-17 15:09:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/cart/components/ProductList/index.vue
-->
<template>
  <div class="con_pro_list">
    <div v-for="(item, index) in productList" :key="index">
      <product
        :item="item"
        @chooseSpec="chooseSpec"
        @deleteProduct="deleteProduct"
        @addLove="addLove"
        @batchSingleSelect="batchSingleSelect"
        @changeNum="changeNum"
        @goProductDetail="goProductDetail"
      />
      <!-- 赠品 -->
      <div v-if="item.giftList" class="free_product_list border_top1px">
        <free-product
          v-for="(item, index) in item.giftList"
          :key="index"
          :showBor="false"
          :freeProduct="item"
          @goProductDetail="goProductDetail"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Product from "../Product";
import FreeProduct from "../FreeProduct";
export default {
  props: {
    productList: {
      type: Array,
      default() {
        return {};
      }
    }
  },
  components: {
    Product,
    FreeProduct
  },
  data() {
    return {};
  },
  methods: {
    chooseSpec(spuId, skuId, id) {
      // console.log(2);
      this.$emit("chooseSpec", spuId, skuId, id);
    },
    deleteProduct(id) {
      this.$emit("deleteProduct", id);
    },
    addLove() {
      this.$toast("加入收藏夹");
    },
    batchSingleSelect(id, isSelected) {
      this.$emit("batchSingleSelect", id, isSelected);
    },
    changeNum(value, id) {
      this.$emit("changeNum", value, id);
    },
    goProductDetail(spuId) {
      this.$emit("goProductDetail", spuId);
    }
  }
};
</script>
<style lang="less" scoped>
.con_pro_list {
  background: #fff !important;
  padding-top: 1px;
  padding-bottom: 1px;
}
.free_product_list {
  margin: 0 12px 24px;
}
</style>
